
  import { css } from 'lit';
  export const styles = css`:host{--file-names-foreground--disabled: var(--ig-file-input-file-names-foreground--disabled, var(--ig-gray-300));--file-selector-button-foreground--disabled: var(--ig-file-input-file-selector-button-foreground--disabled, var(--ig-gray-200));--ig-theme: fluent;--ig-theme-variant: dark}`;
  